export default "__VITE_ASSET__uikNF3Vf__"